var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"b360-grid-row"},[_c('form-dropdowns',{staticClass:"b360-col-xs-12 b360-col-sm-12 b360-col-md-12 b360-col-lg-6",attrs:{"label":'Target Rate Drop (includes your comp plan)',"disabled":_vm.disabled,"options":_vm.rateDropOptions,"name":_vm.rateWatch.name,"value":_vm.rateWatch.parameters.RatePercentageIncrements,"required":true},on:{"change":(e) => {
				if (!_vm.disabled)
					this.updateAlertValue({
						preferenceIndex: _vm.alertIndex,
						key: 'parameters.RatePercentageIncrements',
						value: e.value,
					});
			}}}),_c('label',{staticClass:"b360-form-label b360-col-12"},[_vm._v("Please Select Target Rate (%) or Target Price ($) for the credit toward\n\t\tborrower cost\n\t\t"),_c('font-awesome-icon',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
				content: 'select either a percentage or dollar amount to be used',
				trigger: 'hover click',
				placement: 'top-end',
			}),expression:"{\n\t\t\t\tcontent: 'select either a percentage or dollar amount to be used',\n\t\t\t\ttrigger: 'hover click',\n\t\t\t\tplacement: 'top-end',\n\t\t\t}"}],staticClass:"tooltip-target b360-form-icon",attrs:{"icon":['fal', 'question-circle']}})],1),_c('div',{staticClass:"b360-col-6 pricing-group"},[_c('FormRadioButtons',{attrs:{"radioGroup":[
				{
					name: 'rateWatchPricing',
					label: 'Target Rate (%)',
					value: 0,
					id: 0,
					section: 'rw',
					checked: _vm.isPercent,
				},
			],"isRateWatchPricing":true,"disabled":_vm.disabled},on:{"handle-input":function($event){return _vm.handleRateWatchPricing(true)}}}),_c('FormInputs',{key:_vm.isPercent,attrs:{"name":'percentPrice',"disabled":!_vm.isPercent || _vm.disabled,"value":_vm.isPercent ? _vm.ratePricing : 0,"required":_vm.isPercent,"type":'number',"step":0.01},on:{"handle-input":(emitObj) => {
					if (!_vm.disabled)
						_vm.updateAlertValue({
							preferenceIndex: _vm.alertIndex,
							key: 'parameters.RatePricing',
							value: emitObj.value,
						});
				}}})],1),_c('div',{staticClass:"b360-col-6 pricing-group"},[_c('FormRadioButtons',{attrs:{"radioGroup":[
				{
					name: 'rateWatchPricing',
					label: 'Target Price ($)',
					value: 1,
					id: 1,
					section: 'rw',
					checked: !_vm.isPercent,
				},
			],"isRateWatchPricing":true,"disabled":_vm.disabled},on:{"handle-input":function($event){!_vm.disabled ? _vm.handleRateWatchPricing(false) : ''}}}),_c('FormInputs',{key:_vm.isPercent,attrs:{"name":'dollarPrice',"disabled":_vm.isPercent || _vm.disabled,"value":!_vm.isPercent ? _vm.ratePricing : 0,"type":'number',"step":0.01,"required":!_vm.isPercent},on:{"handle-input":(emitObj) => {
					if (!_vm.disabled)
						_vm.updateAlertValue({
							preferenceIndex: _vm.alertIndex,
							key: 'parameters.RatePricing',
							value: emitObj.value,
						});
				}}})],1),_c('ul',{staticClass:"b360-col-12 pricing-info"},[_c('li',[_vm._v("This loan includes LLPA and the same product type is used.")]),(_vm.rateWatch.parameters.IsTargetAfterComp)?_c('li',[_vm._v("\n\t\t\tYou selected a\n\t\t\t"),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isPercent),expression:"!isPercent"}]},[_vm._v("$")]),_vm._v(_vm._s(_vm.ratePricing)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPercent),expression:"isPercent"}]},[_vm._v("%")]),_vm._v(" credit toward borrower cost.\n\t\t")]):_c('li',[_vm._v("\n\t\t\tYou selected a "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isPercent),expression:"!isPercent"}]},[_vm._v("$")]),_vm._v(_vm._s(_vm.ratePricing)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isPercent),expression:"isPercent"}]},[_vm._v("%")]),_vm._v(" credit toward borrower cost.\n\t\t")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }